// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import store from './store';
import router from './router';
import VueCookie from 'vue-cookie';
import VueLogger from 'vuejs-logger';
import mobileDetect from 'mobile-detect';
import {notification} from './helpers/notification';
import VueVisible from 'vue-visible';
import VueSessionStorage from 'vue-sessionstorage';

var md = new mobileDetect(window.navigator.userAgent);

const logOptions = {
    logLevel: 'debug',
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
};

Vue.prototype.$md = md;
Vue.prototype.$notification = notification;

Vue.use(VueLogger, logOptions);
Vue.use(VueCookie);
Vue.use(VueVisible);
Vue.use(VueSessionStorage);

Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.config.performance = true;

/*
  Adding custom directives to Vue
*/
import {clickOutside} from '@/components/directives/clickOutside';
Vue.directive('click-outside', clickOutside);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
        App
    }
});


// WEBPACK FOOTER //
// ./src/main.js